<div
  *ngIf="isEmpty !== true"
  class="flex flex-shrink-0 items-center justify-center"
  [ngClass]="{
    'mt-[2px]':
      size === 2 &&
      (!result ||
        result === fieldResultString ||
        result === fieldResultDayOfWeek ||
        result === fieldResultDayOfWeekIndex ||
        result === fieldResultMonthName ||
        result === fieldResultQuarterOfYear ||
        (!!result && allResultValues.indexOf(result) < 0)),
    'mb-[2px]':
      size === 3 &&
      (!result ||
        result === fieldResultString ||
        result === fieldResultDayOfWeek ||
        result === fieldResultDayOfWeekIndex ||
        result === fieldResultMonthName ||
        result === fieldResultQuarterOfYear ||
        (!!result && allResultValues.indexOf(result) < 0)),
    'text-g1':
      fieldClass === fieldClassMeasure || fieldClass === fieldClassCalculation,
    'text-m600': fieldClass === fieldClassDimension,
    'text-s500': !fieldClass || fieldClass === fieldClassFilter
  }"
  tp="{{
    result === fieldResultDayOfWeek ||
    result === fieldResultDayOfWeekIndex ||
    result === fieldResultMonthName ||
    result === fieldResultQuarterOfYear
      ? 'Enum: ' + result
      : !!result && allResultValues.indexOf(result) < 0
        ? 'Custom: ' + result
        : !!result
          ? result
          : 'Filter'
  }}"
>
  <m-type-number-icon
    *ngIf="result === fieldResultNumber"
    [size]="size"
  ></m-type-number-icon>

  <m-type-string-icon
    *ngIf="result === fieldResultString"
    [size]="size"
  ></m-type-string-icon>

  <m-type-on-off-icon
    *ngIf="[fieldResultYesno, fieldResultBoolean].indexOf(result) > -1"
    [size]="size"
  ></m-type-on-off-icon>

  <m-type-date-icon
    *ngIf="[fieldResultTs, fieldResultDate].indexOf(result) > -1"
    [size]="size"
  ></m-type-date-icon>

  <m-type-enum-icon
    *ngIf="
      result === fieldResultDayOfWeek ||
      result === fieldResultDayOfWeekIndex ||
      result === fieldResultMonthName ||
      result === fieldResultQuarterOfYear
    "
    [size]="size"
  ></m-type-enum-icon>

  <m-type-custom-icon
    *ngIf="!!result && allResultValues.indexOf(result) < 0"
    [size]="size"
  ></m-type-custom-icon>

  <m-type-filter-icon *ngIf="!result" [size]="size"></m-type-filter-icon>
</div>
